import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['drawer', 'secondaryToggle'];

    connect() {
    }

    initialize() {
        this.tabIndexOff();
    }

    tabIndexOff() {
        this.drawerTarget.querySelectorAll('a').forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
        
        this.drawerTarget.querySelectorAll('button').forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
    }

    tabIndexOn() {
        this.drawerTarget.querySelectorAll('a').forEach(link => {
            link.setAttribute("tabindex", "0"); 
        });
        
        this.drawerTarget.querySelectorAll('button').forEach(link => {
            link.setAttribute("tabindex", "0"); 
        });
    }

    toggle() {
        console.log("toggle");
        
        if (this.element.classList.contains("is-active")) {
            this.close();
            this.tabIndexOff();
        } else {
            this.open();
            this.tabIndexOn();
            this.drawerTarget.focus();
        }
    }

    open() {
        console.log("open");
        this.element.classList.add("is-active");
        window.lenis.stop();
    }

    close() {
        console.log("close");
        this.element.classList.remove("is-active");
        this.closeSecondaryNavigation();
        window.lenis.start();
    }

    toggleSecondaryNavigation(event) {
        event.preventDefault();
        event.stopPropagation();
        
        let currentlyActive = event.target.classList.contains("is-active");

        if (currentlyActive) {
            this.closeSecondaryNavigation();
        } else {    
            this.openSecondaryNavigation();
            event.target.classList.add("is-active");
        }
    }

    closeSecondaryNavigation() {        
        this.drawerTarget.classList.remove("is-secondary-active");
        this.secondaryToggleTargets.forEach(toggle => {
            toggle.classList.remove("is-active");
        });
    }

    openSecondaryNavigation() {
        this.secondaryToggleTargets.forEach(toggle => {
            toggle.classList.remove("is-active");
        });
        this.drawerTarget.classList.add("is-secondary-active");
    }
}
